var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnReset18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_4940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_821_4940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_821_4940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_821_4940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z",
    fill: "#999999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_821_4940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03777 15C7.35064 15 5.91532 14.4187 4.7318 13.2562C3.54829 12.0937 2.95653 10.675 2.95653 9C2.95653 8.95155 2.89755 8.92732 2.86306 8.96152L2.10186 9.7173C1.90634 9.9114 1.58934 9.9114 1.39382 9.7173L1.21904 9.54375C0.926987 9.2538 0.926987 8.7837 1.21904 8.49375L2.2011 7.51875C3.03553 6.69032 4.38841 6.69032 5.22283 7.51875L6.2049 8.49375C6.49695 8.7837 6.49695 9.2538 6.2049 9.54375L6.03011 9.7173C5.83459 9.9114 5.5176 9.9114 5.32208 9.7173L4.56088 8.96152C4.52639 8.92732 4.4674 8.95155 4.4674 9C4.4674 10.25 4.91122 11.3125 5.79885 12.1875C6.68649 13.0625 7.76615 13.5 9.03777 13.5C9.3651 13.5 9.68616 13.4625 10.0009 13.3875C10.1353 13.3555 10.2687 13.3166 10.4008 13.2709C10.7228 13.1595 11.089 13.2115 11.3302 13.451C11.6983 13.8164 11.6166 14.4323 11.1302 14.6167C10.9506 14.6848 10.7694 14.7438 10.5864 14.7938C10.0828 14.9312 9.56658 15 9.03777 15ZM15.7989 10.4813C14.9644 11.3097 13.6116 11.3097 12.7772 10.4813L11.7951 9.50625C11.5031 9.2163 11.5031 8.7462 11.7951 8.45625L11.9699 8.2827C12.1654 8.0886 12.4824 8.0886 12.6779 8.2827L13.4392 9.03848C13.4736 9.07268 13.5326 9.04845 13.5326 9C13.5326 7.74998 13.0888 6.6875 12.2011 5.8125C11.3135 4.9375 10.2338 4.5 8.96223 4.5C8.6349 4.5 8.31384 4.5375 7.99905 4.6125C7.86466 4.64453 7.73133 4.6834 7.5992 4.7291C7.27715 4.84052 6.91097 4.7885 6.6698 4.54906C6.30166 4.18357 6.38341 3.56767 6.86978 3.3833C7.04939 3.31521 7.23066 3.25619 7.41359 3.20625C7.91724 3.06875 8.43343 3 8.96223 3C10.6493 3 12.0847 3.58125 13.2682 4.74375C14.4517 5.90625 15.0435 7.325 15.0435 9C15.0435 9.04845 15.1025 9.07268 15.1369 9.03848L15.8982 8.2827C16.0937 8.0886 16.4106 8.0886 16.6062 8.2827L16.781 8.45625C17.073 8.7462 17.073 9.2163 16.781 9.50625L15.7989 10.4813Z",
    fill: "#999999"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_4940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnReset18);
export default __webpack_public_path__ + "static/media/icn_reset_18.bcb94cc15cae5b8efe19c241568ed723.svg";
export { ForwardRef as ReactComponent };